import { chain, zip, reduce } from 'lodash';
import {
  Board,
  OrderbookSide,
  OrderbookArray,
  OrderbookMap,
  OrderbookArrayWithRak,
  BoardWithRak,
} from '@/types/orderbook';

export const orderbookMap2Array = (orderbookMap: OrderbookMap) => {
  return {
    bids: zip(...[...orderbookMap.bids])[1],
    asks: zip(...[...orderbookMap.asks])[1],
  } as OrderbookArray;
};

export const grouping = (
  orderbookArray: OrderbookArray,
  factor: number,
  rowSize: number,
) => {
  let bids: Board[] = [];
  let asks: Board[] = [];
  Object.keys(orderbookArray).forEach((side) => {
    let tmp1;
    if (side === 'bids') {
      tmp1 = chain(orderbookArray[side as OrderbookSide]).groupBy(
        (value: Board) => {
          return Math.floor(value.price / factor) * factor;
        },
      );
    } else {
      tmp1 = chain(orderbookArray[side as OrderbookSide]).groupBy(
        (value: Board) => {
          return Math.ceil(value.price / factor) * factor;
        },
      );
    }
    const tmp2 = tmp1
      .toPairs()
      .map((value: [string, Board[]]) => {
        // 整数or小数の文字列をNumberに変換
        // +"3.2" => 3.2
        return [+value[0], [...value[1]]];
      })
      .orderBy(0, 'desc');
    let tmp3;
    if (side === 'bids') {
      tmp3 = tmp2.slice(0, rowSize);
    } else {
      tmp3 = tmp2.slice(-rowSize);
    }
    const result = tmp3
      .map((group: [number, Board[]]) => {
        const price = group[0];
        const boardArray = group[1];
        const size = reduce(
          boardArray,
          (sum: number, n: Board) => {
            return sum + n.size;
          },
          0,
        );
        return {
          price,
          size,
        } as Board;
      })
      .orderBy('price', 'desc')
      .value();
    // TODO: unknown
    if (side === 'bids') {
      bids = (result as unknown) as Board[];
    } else {
      asks = (result as unknown) as Board[];
    }
  });
  return {
    bids,
    asks,
  } as OrderbookArray;
};

export const addRank: (
  orderbookArray: OrderbookArray,
) => OrderbookArrayWithRak = (orderbookArray) => {
  let bids: BoardWithRak[] = [];
  let asks: BoardWithRak[] = [];
  Object.keys(orderbookArray).forEach((side) => {
    const result = chain(orderbookArray[side as OrderbookSide])
      .orderBy('size', 'desc')
      .map((value: Board, i: number) => {
        return { ...value, ...{ rank: i } };
      })
      .orderBy('price', 'desc')
      .value();
    if (side === 'bids') {
      bids = result;
    } else {
      asks = result;
    }
  });
  return {
    bids,
    asks,
  };
};

export const paddingOrderbookArray = (
  orderbook: OrderbookArrayWithRak,
  factor: number,
  rowSize: number,
) => {
  if (orderbook.bids.length > 0 && orderbook.bids.length < rowSize) {
    const bids = orderbook.bids;
    const padding = rowSize - bids.length;
    const minPrice = bids[bids.length - 1].price;
    const paddingArray = new Array(padding).fill({}).map((v, i) => {
      return {
        price: minPrice - factor * (i + 1),
        size: 0,
        rank: Number.MAX_SAFE_INTEGER,
      };
    });
    orderbook.bids = [...bids, ...paddingArray];
  }
  if (orderbook.asks.length > 0 && orderbook.asks.length < rowSize) {
    const asks = orderbook.asks;
    const padding = rowSize - asks.length;
    const maxPrice = asks[0].price;
    const paddingArray = new Array(padding).fill({}).map((v, i) => {
      return {
        price: maxPrice + factor * (padding - i),
        size: 0,
        rank: Number.MAX_SAFE_INTEGER,
      };
    });
    orderbook.asks = [...paddingArray, ...asks];
  }
  return orderbook;
};
